<script>
    import { link } from "svelte-routing";

    export let href;

    $: active = href === window.location.pathname;
</script>

<a use:link {href} class:active={active} draggable="false">
    <slot></slot>
</a>

<style>
    a {
        text-decoration: none;
        color: rgba(0, 0, 0, 0.8);
        padding: 1rem 1.5rem;
        line-height: 1;
        border-radius: 0.5rem;
        transition: border-radius 150ms cubic-bezier(0.3, 0.1, 0.25, 1.4);
    }

    a:hover,
    a.active,
    a:focus-visible {
        background-color: #ebe6e2;
        border-radius: 20px;
    }
</style>